import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-scan-summary-card',
  templateUrl: './scan-summary-card.component.html',
  styleUrls: ['./scan-summary-card.component.css']
})
export class ScanSummaryCardComponent {
  @Input() skuStats: any[] = [];
  @Input() validCount: number = 0;
  @Input() totalExpected: number = 0;
  @Input() isOverExpected: boolean = false;

  getTotalSkuCount(): number {
    return this.skuStats.reduce((total, sku) => total + sku.count, 0);
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/distribution-scan/components/scan-summary-card/scan-summary-card.component.ts